import { useEffect, useState } from "react";

const { Spinner } = require("react-bootstrap");

const OnReloadFullScreenLoader = ({ customLoaderValue = false }) => {

    const [loaderVisible, setLoaderVisible] = useState(customLoaderValue);

    useEffect(()=>{setLoaderVisible(customLoaderValue)}, [customLoaderValue])

    useEffect(() => {
        const handleBeforeUnload = () => {
            setLoaderVisible(true); // Show loader when the page is unloading
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);


    if (loaderVisible) {
        return (
            <div
                className="loader d-flex justify-content-center align-items-center"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "black",
                    opacity: 0.7,
                    zIndex: 99999
                }}>
                <Spinner animation="border" variant="primary" color="black" />
            </div>
        )
    } else {
        return <></>;
    }

};

export default OnReloadFullScreenLoader;